import navigation from '@/mixins/navigation'
import DataLayer from '@/utilities/data-layer'

export default {
  mixins: [
    navigation
  ],

  methods: {
    /**
     * Handle Google Sign In Success
     * After signing in with google, get the user's profile information and set it in the store
     */
    async handleGoogleSignInSuccess (googleUser) {
      const profile = googleUser.getBasicProfile()

      await Promise.allSettled([
        this.$_input_updateState('setFirstName', profile.getGivenName()),
        this.$_input_updateState('setLastName', profile.getFamilyName()),
        this.$_input_updateState('setEmail', profile.getEmail())
      ])

      DataLayer.pushEvent('event', `spring_${this.eventPrefix}_google_information_collected`)
    },

    /**
     * Handle Google Sign In Failure
     * This happens if there is an error when signing into google
     */
    handleGoogleSignInFailure (err) {
      console.error(err)
      DataLayer.pushEvent('event', `spring_${this.eventPrefix}_google_popup_closed`)
    }
  }
}
